import React from "react";
import { Cake, Contact, IdCard, Mail, Users } from "lucide-react";

import { DADOS } from "../formato";
import Bloco from "./Bloco";
import Opcao from "./Opcao";

const ICONES = { telefone: Contact, cpf: IdCard, data_nascimento: Cake, email: Mail };

export default function SecaoParticipantes({ config, onMudar }) {
  const exigidos = new Set(config.dados_exigidos || []);
  const alternar = (id) => {
    const novo = new Set(exigidos);
    if (novo.has(id)) novo.delete(id); else novo.add(id);
    novo.add("telefone"); // nome e telefone: mínimo pra existir cadastro
    onMudar("dados_exigidos", DADOS.map((d) => d.id).filter((d) => novo.has(d)));
  };
  return (
    <Bloco icone={Users} titulo="Quem participa"
      subtitulo="Clientes cadastrados com os dados marcados. Quem não tiver vê as ofertas trancadas e o que falta preencher.">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5">
        {DADOS.map((d) => (
          <Opcao key={d.id} e2e={`dado-${d.id}`} icone={ICONES[d.id]} rotulo={d.rotulo} dica={d.dica}
            marcado={d.fixo || exigidos.has(d.id)} fixo={d.fixo} onAlternar={() => alternar(d.id)} />
        ))}
      </div>
    </Bloco>
  );
}
